// https://www.dbos.dev/daily-dbos-actions-count

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';

export function DailyDbosActionsCountPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <section className="hero-title">
        <h1 className="text-heading-h1">Your Daily DBOS Actions Count</h1>
        <p className="text-body text-alignment-left">
          {
            'TO see how many actions\u00a0\u00a0your DBOS executes in a day, run the SQL statement below against your DBOS database.'
          }
        </p>
      </section>
      <pre
        contentEditable="false"
        className="code-block w-code-block"
        style={{ display: 'block', overflowX: 'auto', background: '#2b2b2b', color: '#f8f8f2', padding: '0.5em' }}
        suppressContentEditableWarning
      >
        <code className="language-sql" style={{ whiteSpace: 'pre-wrap' }}>
          <span>
            <span style={{ color: '#dcc6e0' }}>{'WITH'}</span>
            <span>{' daily_workflows '}</span>
            <span style={{ color: '#dcc6e0' }}>{'AS'}</span>
            <span>{' (\n'}</span>
          </span>
          <span>
            <span>{'  '}</span>
            <span style={{ color: '#dcc6e0' }}>{'SELECT'}</span>
            <span>{'\n'}</span>
          </span>
          <span>
            <span>{'    DATE_TRUNC('}</span>
            <span style={{ color: '#abe338' }}>{"'day'"}</span>
            <span>{', TO_TIMESTAMP(created_at '}</span>
            <span className="hljs-operator">{'/'}</span>
            <span> </span>
            <span style={{ color: '#f5ab35' }}>{'1000'}</span>
            <span>{')) '}</span>
            <span style={{ color: '#dcc6e0' }}>{'AS'}</span>
            <span> </span>
            <span style={{ color: '#dcc6e0' }}>{'day'}</span>
            <span>{',\n'}</span>
          </span>
          <span>{'    workflow_uuid\n'}</span>
          <span>
            <span>{'  '}</span>
            <span style={{ color: '#dcc6e0' }}>{'FROM'}</span>
            <span>{' dbos.workflow_status\n'}</span>
          </span>
          <span>{')\n'}</span>
          <span>
            <span />
            <span style={{ color: '#dcc6e0' }}>{'SELECT'}</span>
            <span>{'\n'}</span>
          </span>
          <span>{'  dw.day,\n'}</span>
          <span>
            <span>{'  '}</span>
            <span style={{ color: '#f5ab35' }}>{'COUNT'}</span>
            <span>{'('}</span>
            <span style={{ color: '#dcc6e0' }}>{'DISTINCT'}</span>
            <span>{' dw.workflow_uuid) '}</span>
            <span style={{ color: '#dcc6e0' }}>{'AS'}</span>
            <span>{' workflow_count,\n'}</span>
          </span>
          <span>
            <span>{'  '}</span>
            <span style={{ color: '#f5ab35' }}>{'COUNT'}</span>
            <span>{'(oo.workflow_uuid) '}</span>
            <span style={{ color: '#dcc6e0' }}>{'AS'}</span>
            <span>{' step_count,\n'}</span>
          </span>
          <span>
            <span>{'  '}</span>
            <span style={{ color: '#f5ab35' }}>{'COUNT'}</span>
            <span>{'('}</span>
            <span style={{ color: '#dcc6e0' }}>{'DISTINCT'}</span>
            <span>{' dw.workflow_uuid) '}</span>
            <span className="hljs-operator">{'+'}</span>
            <span> </span>
            <span style={{ color: '#f5ab35' }}>{'COUNT'}</span>
            <span>{'(oo.workflow_uuid) '}</span>
            <span style={{ color: '#dcc6e0' }}>{'AS'}</span>
            <span>{' total_actions\n'}</span>
          </span>
          <span>
            <span />
            <span style={{ color: '#dcc6e0' }}>{'FROM'}</span>
            <span>{' daily_workflows dw\n'}</span>
          </span>
          <span>
            <span />
            <span style={{ color: '#dcc6e0' }}>{'LEFT'}</span>
            <span> </span>
            <span style={{ color: '#dcc6e0' }}>{'JOIN'}</span>
            <span>{' dbos.operation_outputs oo '}</span>
            <span style={{ color: '#dcc6e0' }}>{'ON'}</span>
            <span>{' dw.workflow_uuid '}</span>
            <span className="hljs-operator">{'='}</span>
            <span>{' oo.workflow_uuid\n'}</span>
          </span>
          <span>
            <span />
            <span style={{ color: '#dcc6e0' }}>{'GROUP'}</span>
            <span> </span>
            <span style={{ color: '#dcc6e0' }}>{'BY'}</span>
            <span>{' dw.day\n'}</span>
          </span>
          <span>
            <span />
            <span style={{ color: '#dcc6e0' }}>{'ORDER'}</span>
            <span> </span>
            <span style={{ color: '#dcc6e0' }}>{'BY'}</span>
            <span>{' dw.day '}</span>
            <span style={{ color: '#dcc6e0' }}>{'DESC'}</span>
            <span>{';'}</span>
          </span>
        </code>
      </pre>
    </SiteLayout>
  );
}
